// src/components/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles.css'; // Assuming styles.css has .header, .navbar, .nav-menu, etc.

function Navbar({ showSignUpButton = true }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <div className="header-content">
        <img src="/Casalytix Logo.png" alt="Casalytix Logo" className="logo" />
        <div className="hamburger-menu" onClick={toggleMenu}>☰</div>
        <nav className="navbar">
          <ul className={`nav-menu ${isMenuOpen ? 'block' : ''}`}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/dashboard">Dashboard</Link></li>
          </ul>
          {showSignUpButton && (
            <button className="sign-up-btn" onClick={() => window.location.href = '/login'}>
              Log in
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Navbar;